"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9524],{

/***/ 69524:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ FooterCompact; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../libs/matcha/components/SegmentLogo/index.ts + 2 modules
var SegmentLogo = __webpack_require__(84672);
// EXTERNAL MODULE: ../../libs/matcha/components/Divider/index.ts + 1 modules
var Divider = __webpack_require__(76305);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Footer/useTrustArcLink.ts
var useTrustArcLink = __webpack_require__(9642);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/FooterCompact/FooterCompact.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var MenuItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("li",  true ? {
  target: "eaptrme6"
} : 0)("color:", function (_ref) {
  var color = _ref.color;
  return color;
}, ";display:flex;align-self:center;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.down("sm");
}, "{text-align:center;margin:5px 0;}" + ( true ? "" : 0));
var MenuLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("a",  true ? {
  target: "eaptrme5"
} : 0)("color:", function (_ref3) {
  var color = _ref3.color;
  return color;
}, ";text-decoration:underline;" + ( true ? "" : 0));
var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eaptrme4"
} : 0)("width:100%;", function (_ref4) {
  var theme = _ref4.theme;
  return theme.typography.pSmall;
}, " padding:10px 40px 0;background:", function (_ref5) {
  var background = _ref5.background;
  return background;
}, ";", function (_ref6) {
  var theme = _ref6.theme;
  return theme.breakpoints.up("lg");
}, "{padding:10px 80px 0;}" + ( true ? "" : 0));
var DividerLine = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "eaptrme3"
} : 0)( true ? {
  name: "x85wbw",
  styles: "padding:0 5px"
} : 0);
var FooterContent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("footer",  true ? {
  target: "eaptrme2"
} : 0)("margin:0 auto;padding:35px 0 40px;display:grid;grid-template-columns:none;gap:28px;", function (_ref7) {
  var theme = _ref7.theme;
  return theme.breakpoints.up("md");
}, "{grid-template-columns:1fr auto;grid-template-rows:none;gap:80px;max-width:1280px;}" + ( true ? "" : 0));
var MenuLinks = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("ul",  true ? {
  target: "eaptrme1"
} : 0)("margin:0;padding:0;display:flex;", function (_ref8) {
  var theme = _ref8.theme;
  return theme.breakpoints.down("sm");
}, "{flex-wrap:wrap;justify-content:center;}" + ( true ? "" : 0));
var BrandLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eaptrme0"
} : 0)("display:grid;grid-template-columns:1fr;", function (_ref9) {
  var theme = _ref9.theme;
  return theme.breakpoints.down("sm");
}, "{>*:first-child{margin:0 auto;}}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
;// CONCATENATED MODULE: ../../libs/templates/FooterCompact/FooterCompact.tsx


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}












var data = {
  bottomLinks: [{
    url: "https://www.twilio.com/legal/privacy/",
    title: "Privacy"
  }, {
    url: "https://www.twilio.com/legal/tos/",
    title: "Terms"
  }],
  copyright: "\xA9 ".concat(new Date().getUTCFullYear(), " Twilio Inc. All Rights Reserved.")
};

var BaseFooterCompact = function BaseFooterCompact(_ref) {
  var tokens = _ref.tokens,
      _ref$divider = _ref.divider,
      divider = _ref$divider === void 0 ? false : _ref$divider,
      backgroundColor = _ref.backgroundColor;
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var hasTrustArcEnabled = (0,useTrustArcLink/* default */.Z)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, {
    background: backgroundColor || tokens.background,
    children: [divider && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FooterContent, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: (0,getAbsoluteUrl/* default */.Z)("/", pageConfig),
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BrandLink, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
            appearance: tokens.logoAppearance,
            alt: "Twilio, Inc.",
            footer: true
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MenuLinks, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem, _objectSpread(_objectSpread({}, tokens.menuItem), {}, {
          children: data.copyright
        })), data.bottomLinks.map(function (_ref2) {
          var title = _ref2.title,
              url = _ref2.url;
          return (0,emotion_react_browser_esm/* createElement */.az)(MenuItem, _objectSpread(_objectSpread({}, tokens.menuItem), {}, {
            key: title
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DividerLine, {
            children: "|"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuLink, _objectSpread(_objectSpread({}, tokens.menuLink), {}, {
            href: url,
            children: title
          })));
        }), hasTrustArcEnabled && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MenuItem, _objectSpread(_objectSpread({}, tokens.menuItem), {}, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DividerLine, {
            children: "|"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuLink, _objectSpread(_objectSpread({}, tokens.menuLink), {}, {
            id: "teconsent"
          }))]
        }))]
      })]
    })]
  });
};

var FooterCompact = (0,useDesignTokens/* withDesignTokens */.Y)(BaseFooterCompact, function () {
  return {};
}, {
  dark: function dark(theme) {
    return {
      background: theme.palette.twilio.gray[10],
      menuItem: {
        color: theme.palette.twilio.gray[100]
      },
      menuLink: {
        color: theme.palette.twilio.gray[100]
      },
      logoAppearance: "light"
    };
  },
  light: function light(theme) {
    return {
      background: theme.palette.twilio.gray[10],
      menuItem: {
        color: theme.palette.twilio.gray[100]
      },
      menuLink: {
        color: theme.palette.twilio.gray[100]
      },
      logoAppearance: "light"
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      background: theme.palette.twilio.gray[10],
      menuItem: {
        color: theme.palette.twilio.gray[100]
      },
      menuLink: {
        color: theme.palette.twilio.gray[100]
      },
      logoAppearance: "light"
    };
  },
  twilioDark: function twilioDark(theme) {
    return {
      background: theme.palette.twilio.gray[100],
      menuItem: {
        color: theme.palette.neutrals.white[100]
      },
      menuLink: {
        color: theme.palette.neutrals.white[100]
      },
      logoAppearance: "twilioDark"
    };
  },
  cdpWeek2023: function cdpWeek2023(theme) {
    return {
      background: theme.palette.twilio.gray[10],
      menuItem: {
        color: theme.palette.twilio.gray[100]
      },
      menuLink: {
        color: theme.palette.twilio.gray[100]
      },
      logoAppearance: "light"
    };
  }
});
;// CONCATENATED MODULE: ../../libs/templates/FooterCompact/index.ts


/***/ })

}]);